module.exports = __webpack_public_path__ + "media/images/ruutz-logo-color-4ab78efbeca5dacbe8e9ac60aa7ba724.png";